import StaffAssignedIcon from 'components/elements/icons/StaffAssignedIcon'
import InformationContent from 'components/elements/items/InformationContent'
import LoaderBar from 'components/elements/items/LoaderBar'
import RequestedTemplate from 'components/templates/RequestedTemplate'
import React from 'react'
import { QnStatesProps } from 'states/QnState'
import { StatesProps } from 'utils/commonHooks'

/**
 * QN-10: スタッフ決定画面
 */
const Assigned: React.FC<StatesProps> = (props: QnStatesProps) => {
  const { state } = props

  return (
    <RequestedTemplate
      title={'スタッフ決定画面'}
      content={
        <InformationContent
          items={[
            {
              icon: <StaffAssignedIcon />,
              marginBottom: '15px',
            },
            {
              message: 'スタッフが見つかりました',
              large: true,
            },
            {
              message:
                '位置情報が共有できる車両の場合は、\n位置共有画面が開きます。',
              small: true,
            },
            {
              icon: <LoaderBar />,
            },
          ]}
        />
      }
      state={state}
    />
  )
}

export default Assigned
